module.exports = __webpack_public_path__ + "static/media/fidelis.d8c225c5.png";